<template>
  <div :id="id + '_ticket'" class="ticket" v-if="donation" v-on:click="download">
    <div class="left-side">
      <div class="bg"></div>
      <div class="badge">
        <div class="title">
          CORONA
          <br />Solidarität
        </div>
        <div class="hashtag">#solidarity4kmu</div>
        <div class="link">www.covida.ch</div>
      </div>
    </div>
    <div class="right-side text-center">
      <h6 class="title">Beim nächsten Besuch<br/>bezahle ich</h6>
      <div class="price">
        <h5 class="unit">CHF</h5>
        <div class="money">{{donation.value | toCurrencyWithoutSymbolAndDecimals}}</div>
        <h5 class="description">extra</h5>
      </div>
      <!-- <div>#{{donation.donateNumber}}</div> -->
      <h6 v-if="company" class="place"><span class="ticket-here-lbl">hier </span> {{company.name}}</h6>
    </div>
  </div>
</template>

<script>
import * as html2canvas from "html2canvas";
import firebase from "firebase/app";
let db = firebase.firestore();
let donationsRef = db.collection("donations");

export default {
  props: ['id'],
  data: function(){
    return {
      company: null,
      donation: null
    }
  },
  mounted: function(){
     let $this = this;
    donationsRef
      .doc(this.id)
      .get()
      .then(function(querySnapshot) {
        if (!querySnapshot.exists) {
          return;
        }

        $this.donation = querySnapshot.data();

        querySnapshot
          .data()
          .to.get()
          .then(function(querySnapshot) {
            $this.company = querySnapshot.data();
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },
  methods: {
    download: function() {
      html2canvas(document.querySelector("#" + this.id + '_ticket')).then(function(canvas) {
        var link = document.createElement("a");
        link.style.cssText = "display: none;";
        let url = canvas.toDataURL();
        if (typeof link.download === "string") {
          link.href = url;
          link.download = "ticket.png";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          window.open(url);
        }
      });
    }
  }
};
</script>

<style>
</style>
